/* ============================================================
   RPW CUSTOM THRONE - TRACKING  (assets/rpw-custom-track.js)   v1
   Sends what people do in the custom hood builder to Klaviyo, so every
   design is on record even when nobody buys. Loaded by
   sections/rpw-custom-builder.liquid and snippets/rpw-custom-wishlist.liquid.
   Delete those two script lines to stop tracking; nothing else changes.

   HOW IT WORKS
   - Every browser gets one id, SID (localStorage rpwcx_sid - the same id the
     survey uses). Events go to Klaviyo's client API against a profile whose
     external_id is that SID, so anonymous visitors are tracked too. Profiles
     with only an external_id are not emailable, so they do not count toward
     Klaviyo's active-profile billing. Once an email is known (survey, wishlist
     email, or a Klaviyo-identified visitor) it is sent alongside the SID and
     Klaviyo merges the two into one profile.
   - rpw-custom-core.js fires DOM events 'rpwcx:track' {ev, props}; this file
     listens and posts them. Metrics created in Klaviyo:
       Custom Hood Page Viewed      - a custom hood PDP loaded (handle, utm, referrer)
       Custom Hood Builder Opened   - the popup builder opened (mobile)
       Custom Hood Step             - first time each step is reached per page view
                                      (step, step_index, steps) -> the fall-off funnel
       Custom Hood Designed         - the Review step was reached: the full build,
                                      design (one-line key), design_no in this browser,
                                      previous_designs (last 10 in this browser)
       Custom Hood Added to Cart    - same fields + build_id, price. build_id is also
                                      on the cart line (_build / _cx_sid) so orders join
                                      back to designs.
       Custom Hood Saved            - saved to the wishlist (same fields)
       Wishlist Emailed             - the wishlist email was requested (items)
   - unique_id on every event = SID + event + session + step/design, so a reload
     or a double click never double counts.
   To pull a report: Klaviyo > Analytics > Metrics, or export the events
   (the report script lives with the project files: survey/report.py).
   ============================================================ */
(function(){
  'use strict';
  if (window.__rpwcxTrack) return; window.__rpwcxTrack = 1;
  var COMPANY = (window.RPWCX_TRACK_CFG && window.RPWCX_TRACK_CFG.company) || 'QTD4d6';
  var KAPI = 'https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(COMPANY), REV = '2024-10-15';
  function ls(k, v){ try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch(e){ return null; } }
  var SID = (function(){ var s = ls('rpwcx_sid'); if (!s){ s = 'S-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2,7).toUpperCase(); ls('rpwcx_sid', s); } return s; })();
  window.RPWCX_SID = SID;
  var SESSION = 'P-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2,5).toUpperCase();   /* one per page view */
  var seq = 0, sent = {};
  function email(){ return ls('rpwcx_email') || ''; }
  function setEmail(e){ if (e && /@/.test(e)) ls('rpwcx_email', String(e).trim().toLowerCase()); }
  function utm(){ var o = {}, q = location.search.replace(/^\?/, '').split('&'); q.forEach(function(kv){ var p = kv.split('='); if (/^utm_/.test(p[0])) o[p[0]] = decodeURIComponent((p[1]||'').replace(/\+/g,' ')); }); return o; }
  function designs(){ try { return JSON.parse(ls('rpwcx_designs') || '[]'); } catch(e){ return []; } }
  function rememberDesign(d){ var a = designs(); if (a[a.length-1] !== d) a.push(d); if (a.length > 50) a = a.slice(-50); ls('rpwcx_designs', JSON.stringify(a)); return a; }

  function post(ev, props, uid){
    var profile = { external_id: SID, properties: { custom_hood_sid: SID } };
    var em = email(); if (em) profile.email = em;
    var body = { data:{ type:'event', attributes:{ properties: props, unique_id: uid, metric:{ data:{ type:'metric', attributes:{ name: ev } } }, profile:{ data:{ type:'profile', attributes: profile } } } } };
    try {
      return fetch(KAPI, { method:'POST', headers:{ 'Content-Type':'application/json', 'revision':REV }, body: JSON.stringify(body), keepalive: true }).catch(function(){});
    } catch(e){ return Promise.resolve(); }
  }
  function base(){ return { sid: SID, session: SESSION, seq: ++seq, page: location.pathname, device: (/Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'), utm_source: utm().utm_source || '', utm_campaign: utm().utm_campaign || '', referrer: document.referrer || '' }; }
  function send(ev, props, key){
    props = Object.assign(base(), props || {});
    var uid = SID + ':' + ev + ':' + (key || SESSION + ':' + seq);
    if (sent[uid]) return; sent[uid] = 1;
    return post(ev, props, uid);
  }

  document.addEventListener('rpwcx:track', function(e){
    var d = e.detail || {}, ev = d.ev, p = d.props || {};
    if (!ev) return;
    if (ev === 'Custom Hood Step'){ send(ev, p, SESSION + ':' + p.step); return; }
    if (ev === 'Custom Hood Designed'){
      var all = rememberDesign(p.design);
      send(ev, Object.assign({ design_no: all.length, previous_designs: all.slice(0, -1).slice(-10) }, p), SESSION + ':' + p.design);
      return;
    }
    if (ev === 'Custom Hood Added to Cart' || ev === 'Custom Hood Saved'){
      var a = designs(); send(ev, Object.assign({ design_no: a.length, previous_designs: a.slice(-10) }, p), p.build_id || (SESSION + ':' + p.design + ':' + Date.now()));
      return;
    }
    if (ev === 'Identify'){ setEmail(p.email); return; }
    send(ev, p);
  });

  /* a custom hood product page was viewed */
  if (window.RPWCX_PDP && window.RPWCX_PDP.handle){
    send('Custom Hood Page Viewed', { handle: window.RPWCX_PDP.handle, designs_so_far: designs().length }, SESSION);
  }
  /* visitors Klaviyo already knows (came from an email / SMS link): nothing to read client-side, but klaviyo.js will have cookied them, so also mirror our events there once identified */
  window.RPWCX_TRACKER = { sid: SID, session: SESSION, setEmail: setEmail, designs: designs, send: send };
})();
